/**
 * Copy text to the clipboard, reporting whether it landed.
 *
 * `navigator.clipboard` is unavailable on insecure origins and throws when the
 * document is not focused, so the caller has to be able to tell a silent
 * failure from a copy — an id the user believes they copied and did not is
 * worse than an error toast.
 */
export const copyToClipboard = async (text: string): Promise<boolean> => {
  if (!text || !navigator.clipboard?.writeText) return false;
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
};
